var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 92,
    viewBox: "0 0 108 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8264_81603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 29.5C32 21.768 38.268 15.5 46 15.5H62C69.732 15.5 76 21.768 76 29.5V45.5C76 53.232 69.732 59.5 62 59.5H46C38.268 59.5 32 53.232 32 45.5V29.5Z",
    fill: "url(#paint0_linear_8264_81603)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8264_81603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 29.5C32 21.768 38.268 15.5 46 15.5H62C69.732 15.5 76 21.768 76 29.5V45.5C76 53.232 69.732 59.5 62 59.5H46C38.268 59.5 32 53.232 32 45.5V29.5Z",
    fill: "url(#paint1_linear_8264_81603)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9297 30.4425C43.9297 29.9133 44.3587 29.4844 44.8878 29.4844H63.12C63.6492 29.4844 64.0781 29.9133 64.0781 30.4425V34.125H43.9297V30.4425Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9219 34.2891V33.2891H44.9219V34.2891H45.9219ZM52.0439 34.2891H53.0439V33.2891H52.0439V34.2891ZM52.0439 37.6484H51.0439V38.6484H52.0439V37.6484ZM56.125 37.6484V38.6484H57.125V37.6484H56.125ZM56.125 34.2891V33.2891H55.125V34.2891H56.125ZM62.2461 34.2891H63.2461V33.2891H62.2461V34.2891ZM62.2461 44.5527H61.2461C61.2461 44.5485 61.2472 44.542 61.2499 44.5355C61.2524 44.5297 61.2555 44.5255 61.2584 44.5226C61.2614 44.5196 61.2654 44.5167 61.2709 44.5143C61.2771 44.5117 61.2832 44.5107 61.2871 44.5107V45.5107V46.5107C62.3672 46.5107 63.2461 45.6355 63.2461 44.5527H62.2461ZM61.2871 45.5107V44.5107H46.8809V45.5107V46.5107H61.2871V45.5107ZM46.8809 45.5107V44.5107C46.8847 44.5107 46.8908 44.5117 46.897 44.5143C46.9025 44.5167 46.9066 44.5196 46.9095 44.5226C46.9125 44.5255 46.9156 44.5297 46.9181 44.5355C46.9208 44.542 46.9219 44.5485 46.9219 44.5527H45.9219H44.9219C44.9219 45.6355 45.8007 46.5107 46.8809 46.5107V45.5107ZM45.9219 44.5527H46.9219V34.2891H45.9219H44.9219V44.5527H45.9219ZM45.9219 34.2891V35.2891H52.0439V34.2891V33.2891H45.9219V34.2891ZM52.0439 34.2891H51.0439V37.6484H52.0439H53.0439V34.2891H52.0439ZM52.0439 37.6484V38.6484H56.125V37.6484V36.6484H52.0439V37.6484ZM56.125 37.6484H57.125V34.2891H56.125H55.125V37.6484H56.125ZM56.125 34.2891V35.2891H62.2461V34.2891V33.2891H56.125V34.2891ZM62.2461 34.2891H61.2461V44.5527H62.2461H63.2461V34.2891H62.2461Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8264_81603)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8264_81603",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 19.5C66 16.1863 68.6863 13.5 72 13.5C75.3137 13.5 78 16.1863 78 19.5C78 22.8137 75.3137 25.5 72 25.5C68.6863 25.5 66 22.8137 66 19.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 19.5C66 16.1863 68.6863 13.5 72 13.5C75.3137 13.5 78 16.1863 78 19.5C78 22.8137 75.3137 25.5 72 25.5C68.6863 25.5 66 22.8137 66 19.5Z",
    fill: "url(#paint2_linear_8264_81603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 19.5M78 19.5M78 19.5M66 19.5M72 13.5M78 19.5M72 25.5M66 19.5M72 25.5V23.5C69.7909 23.5 68 21.7091 68 19.5H66H64C64 23.9183 67.5817 27.5 72 27.5V25.5ZM78 19.5H76C76 21.7091 74.2091 23.5 72 23.5V25.5V27.5C76.4183 27.5 80 23.9183 80 19.5H78ZM72 13.5V15.5C74.2091 15.5 76 17.2909 76 19.5H78H80C80 15.0817 76.4183 11.5 72 11.5V13.5ZM72 13.5V11.5C67.5817 11.5 64 15.0817 64 19.5H66H68C68 17.2909 69.7909 15.5 72 15.5V13.5Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8264_81603)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8264_81603",
    x: 0,
    y: -16.5,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8264_81603"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8264_81603",
    x: 20,
    y: 13.5,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81603",
    result: "effect2_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8264_81603",
    x: 54,
    y: 11.5,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81603",
    result: "effect2_dropShadow_8264_81603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8264_81603",
    x1: 32,
    y1: 15.5,
    x2: 76,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1447E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8264_81603",
    x1: 32,
    y1: 15.5,
    x2: 76,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1447E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8264_81603",
    x1: 66,
    y1: 13.5,
    x2: 78,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1447E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/Total Orders.7dac5610047ed77e465b359fe81545b0.svg";
export { ForwardRef as ReactComponent };